export default defineNuxtPlugin({
  name: 'meta-pixel-tracking',
  dependsOn: ['cookiebot'],
  setup() {
    const { metaPixel, mode } = useRuntimeConfig().public
    const systemStore = useSystemStore()

    if (!metaPixel.id || mode !== 'production' || systemStore.platform !== 'EU') {
      return {}
    }

    const router = useRouter()
    const { logError } = useErrorHandling()
    const { $cookiebot } = useNuxtApp()

    const trackedRoutes = [
      'business-register',
      'business-signup',
      'business-signup-mail-sent',
      'business-signup-steps',
      'business-welcome',
    ]

    const shouldTrack = (routeName?: string | symbol | null) =>
      routeName && trackedRoutes.includes(routeName.toString())

    const hasMarketingConsent = computed(() => {
      const cbInstance = $cookiebot.instance
      if (!cbInstance) return false

      return cbInstance.consented && cbInstance.consent.marketing
    })

    const { proxy, onError } = useScriptMetaPixel({
      id: metaPixel.id,
      scriptOptions: {
        trigger: hasMarketingConsent,
      },
    })

    onError(error => {
      logError('Meta pixel script loading failed', error)
    })

    // Track page views on route changes (only for tracked routes and when consent is given)
    router.afterEach(to => {
      if (hasMarketingConsent.value && shouldTrack(to.name)) {
        proxy.fbq('track', 'PageView')
      }
    })

    return {}
  },
})
